import { getAnalyticsClient } from '@/shared/analytics/posthog';
import { useAnalyticsIdentity } from '@/shared/analytics/useAnalyticsIdentity';
import { usePageviewTracking } from '@/shared/analytics/usePageviewTracking';
import { PostHogProvider } from 'posthog-js/react';
import type { ReactNode } from 'react';

/**
 * Runs the analytics wiring hooks inside router + auth-store context. Kept as a
 * child (not the provider body) so the hooks mount within `PostHogProvider`.
 */
function AnalyticsWiring({ children }: { children: ReactNode }) {
  useAnalyticsIdentity();
  usePageviewTracking();
  return <>{children}</>;
}

/**
 * Wraps the app with the PostHog React provider using the already-initialized
 * client (call `initAnalytics()` at bootstrap first). When analytics is
 * unconfigured the client is `null` — render children unchanged, so nothing is
 * captured and no context is provided.
 */
export function PostHogAppProvider({ children }: { children: ReactNode }) {
  const client = getAnalyticsClient();

  if (!client) return <>{children}</>;

  return (
    <PostHogProvider client={client}>
      <AnalyticsWiring>{children}</AnalyticsWiring>
    </PostHogProvider>
  );
}
